// TODO: Handle expired token

import { AuthInfos } from '../models/auth-infos'
import { httpService, HttpService } from './http.service'

class AuthService {
  readonly TBWJF = 'tbw-auth-infos'
  private _authInfos: AuthInfos | null = null
  private token: string

  constructor(private _httpService: HttpService) {
  }

  #HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }

  get isAuthenticated() {
    return !!this._authInfos
  }

  get authInfos(): AuthInfos {
    return this._authInfos
  }

  notify(authenticated: boolean) {
    const customEvent = new CustomEvent('authChange', {
      detail: { authenticated },
      bubbles: true,
      cancelable: true
    });

    document.dispatchEvent(customEvent);
  }

  async sendEmail(email: string) {
    try {
      const response = await this._httpService.query('sessions/query', {
        method: 'POST',
        headers: this.#HEADERS,
        body: JSON.stringify({ email })
      })
      if (!response.ok) { throw new Error('invalidOTPCode') }
      return await response.json()
    } catch (error) {
      console.error(error)
    }
  }

  async sendOTP(email: string, OTPCode: number) {
    try {
      const response = await this._httpService.query('sessions/', {
        method: 'POST',
        headers: this.#HEADERS,
        body: JSON.stringify({ email, OTPCode })
      })
      if (!response.ok) { throw new Error('invalidOTPCode') }
      const body = await response.json()
      this.register(body.token)
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  }

  register(token: string) {
    this.token = token
    localStorage.setItem(this.TBWJF, token)
  }

  logout() {
    this.clear()
  }

  private clear() {
    this._authInfos = null
    localStorage.removeItem(this.TBWJF)
    this._httpService.clearAuth()
    this.notify(false)
  }

  private getFromStorage(): string | null {
    return localStorage.getItem(this.TBWJF)
  }

  async checkAuth() {
    const token = this.getFromStorage()

    if (!token) {
      this.notify(false)
      return false
    }
    else {
      this.token = token
      this._httpService.setAuth(token)
    }

    const response = await this._httpService.query('sessions/', { method: 'GET', })

    if (!response.ok) {
      this.clear()
      return false
    }

    const authInfos = await response.json() as AuthInfos

    if (!authInfos.userAccess || !authInfos.userEmail || !authInfos.userAirTableId) {
      console.error('invalid authInfos', authInfos)
      this.clear(); return false
    }

    this._authInfos = authInfos

    this.notify(true)
    return true
  }
}

export const authService = new AuthService(httpService)

// Extend the Window interface to include authService
declare global {
  interface Window {
    authService: AuthService;
  }
}

// Inject to Global scope
window.authService = authService